<ng-container
  *ngTemplateOutlet="requestSuccessful ? requestReceived : requestForm"
></ng-container>

<ng-template #requestForm>
  <div class="flex flex-column gap-4">
    <img
      src="../../../../assets/images/logo-original.svg"
      alt="Mercury logo"
      class="mercury-logo"
    />
    <div class="flex flex-column gap-2">
      <span class="text-primary jumbo-medium"> Request an account</span>
      <span class="text-tertiary body-medium"
        >Your request will be reviewed and our sales team contact you as soon as
        possible.</span
      >
    </div>
    <div class="flex flex-column gap-2" [formGroup]="form">
      <div class="flex flex-column gap-2">
        <label for="companyName" class="text-secondary field-label-medium"
          >Company Name <span class="required-marker">*</span></label
        >
        <input
          data-hj-allow
          type="text"
          pInputText
          formControlName="companyName"
          id="companyName"
          placeholder="Enter Company Name"
          [maxLength]="50"
        />
        <me-form-validation-message
          label="Company Name"
          controlName="companyName"
        ></me-form-validation-message>
      </div>
      <div class="flex flex-column gap-2">
        <label for="companyWebsite">
          Company Website <span class="required-marker">*</span></label
        >
        <div class="flex flex-row gap-0 w-full">
          <div
            class="text-align-center text-tertiary subtitle-small left-addon"
          >
            https://
          </div>
          <input
            data-hj-allow
            type="text"
            pInputText
            formControlName="companyWebsite"
            id="companyWebsite"
            placeholder="www.companysite.com"
            class="right-input w-full"
            [maxLength]="245"
          />
        </div>
        <me-form-validation-message
          controlName="companyWebsite"
          label="Company Website"
        ></me-form-validation-message>
      </div>
      <div class="flex flex-column gap-2">
        <label for="contactName" class="text-secondary field-label-medium"
          >Contact Name <span class="required-marker">*</span></label
        >
        <input
          data-hj-allow
          type="text"
          pInputText
          formControlName="contactName"
          id="contactName"
          placeholder="Enter Contact Name"
          [maxLength]="50"
        />
        <me-form-validation-message
          controlName="contactName"
          label="Contact Name"
        ></me-form-validation-message>
      </div>
      <div class="flex flex-column gap-2">
        <label for="contactPhone" class="text-secondary field-label-medium"
          >Contact Phone <span class="required-marker">*</span></label
        >
        <me-phone
          #phone
          formGroupName="contactPhone"
          (phoneValidationOnChange)="isPhoneNumberValid = $event"
        ></me-phone>
      </div>
      <div class="flex flex-column gap-2">
        <label for="contactEmail" class="text-secondary field-label-medium"
          >Contact Email <span class="required-marker">*</span></label
        >
        <input
          data-hj-allow
          type="email"
          pInputText
          formControlName="contactEmail"
          id="contactEmail"
          placeholder="Enter Contact Email"
          [maxlength]="255"
        />
        <me-form-validation-message
          controlName="contactEmail"
          label="Contact Email"
        ></me-form-validation-message>
      </div>
    </div>
    <div class="flex flex-row justify-content-between">
      <me-button
        type="secondary"
        size="medium"
        label="Back to Login"
        (click)="navigateToLogin()"
      ></me-button>
      <me-button
        type="primary"
        size="medium"
        label="Request"
        (click)="
          enableRecaptcha ? submitRequestWithCaptcha() : requestAccount()
        "
      ></me-button>
    </div>
  </div>
</ng-template>

<ng-template #requestReceived>
  <div class="flex flex-column gap-4">
    <img
      src="../../../../assets/images/logo-original.svg"
      alt="Mercury logo"
      class="mercury-logo"
    />
    <div class="text-primary jumbo-medium flex flex-row gap-2">
      <i class="icon-bx-check-circle"></i>
      <span>Your account request has been received</span>
    </div>
    <div class="text-tertiary body-medium">
      We received your request. Our sales team will contact you as soon as
      possible. In the meantime you can use “Guest Shipping” to book a shipment
      right away.
    </div>
    <div class="flex flex-row justify-content-between">
      <me-button
        type="secondary"
        size="medium"
        label="Ship as a Guest"
        (click)="navigateToShipLite()"
      ></me-button>
      <me-button
        type="primary"
        size="medium"
        label="Back to shipmercury.com"
        (click)="navigateToShipMercury()"
      ></me-button>
    </div>
  </div>
</ng-template>

@if (enableRecaptcha) {
  <re-captcha
    #captchaRef
    (resolved)="resolved($event)"
    [siteKey]="captchaPublicSiteKey"
    size="invisible"
  ></re-captcha>
}
